import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import AddIcon from "@material-ui/icons/Add";
import FormControl from "@material-ui/core/FormControl";
import Input from "@material-ui/core/Input";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import withStyles from "@material-ui/core/styles/withStyles";
import InputLabel from "@material-ui/core/InputLabel";
// ---------------  For Redux ----------------------------------
import { connect } from "react-redux";
import { compose } from "redux";
// import { firestoreConnect } from 'react-redux-firebase'
import {
  createTask,
  createTaskReset,
} from "../../../store/actions/TaskActions";
import UserPicker from "../../custom/UserPicker";
import PriorityPicker from "../../custom/PriorityPicker";
import moment from "moment";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { checkA, getCollection } from "../../../constant";
import Loader from "../../custom/loader";
import { firestoreConnect } from "react-redux-firebase";
import CKEditor from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

const styles = (theme) => ({
  layout: {
    width: "auto",
    display: "block", // Fix IE11 issue.
    marginLeft: theme.spacing(3),
    marginRight: theme.spacing(3),
    [theme.breakpoints.up(400 + theme.spacing(3) * 2)]: {
      width: 800,
      marginLeft: "auto",
      marginRight: "auto",
    },
  },
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: `${theme.spacing(2)}px ${theme.spacing(3)}px ${theme.spacing(
      3
    )}px`,
  },
  avatar: {
    margin: theme.spacing(),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE11 issue.
    marginTop: theme.spacing(),
  },
  submit: {
    marginTop: theme.spacing(3),
  },

  modalMain: {
    position: "fixed",
    background: "rgba(0,0,0,.5)",
    zIndex: 1,
    margin: "auto",
    left: 0,
    top: 0,
    bottom: 0,
    width: "100vw",
    height: "100vh",
  },
  modalInner: {
    maxWidth: 700,
    width: "80%",
    margin: "auto",
    background: "#fff",
    marginTop: 50,
    borderRadius: 10,
    maxHeight: "90vh",
    overflow: "scroll",
  },
});

class TaskForm extends React.Component {
  state = {
    open: false,
    scroll: "paper",
    title: "",
    content: "",
    startDateTime: moment().format("Y-MM-DDThh:mm"),
    endDateTime: moment().format("Y-MM-DDThh:mm"),
    assignee: null,
    priority: "Medium",
  };

  componentDidMount() {
    // console.log('this.props : ', this.props)
  }

  handleClose = () => {
    this.setState({ open: false, scroll: "paper" });
  };

  handleClickOpen = (scroll) => () => {
    this.setState({ open: true, scroll });
    if (this.props.task) {
      const {
        id,
        title,
        content,
        startDateTime,
        endDateTime,
        assignee,
        priority,
        complete,
        reopen,
      } = this.props.task;
      console.log("this.props.task : ", this.props.task);
      this.setState({
        id,
        title,
        content,
        startDateTime,
        endDateTime,
        assignee,
        priority,
        complete,
        reopen,
      });
    }
  };

  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value,
    });
  };

  handleEditorChange = (html) => {
    this.setState({ content: html });
  };

  handleCreate = (e) => {
    e.preventDefault();

    const {
      title,
      content,
      assignee,
      id,
      comments,
      reopen,
      complete,
    } = this.state;
    const { profile, task: MainTask, project } = this.props;

    if (!title) {
      this.setState({ saveError: "Please add task title" });
      return;
    }

    if (!content) {
      this.setState({ saveError: "Please add task description" });
      return;
    }

    if (!assignee || (assignee && !assignee.length)) {
      this.setState({ saveError: "Please choose a assignee" });
      return;
    }

    const assigneeIds = [];
    assignee.forEach((user) => {
      assigneeIds.push(user.id);
    });

    const task = {
      ...this.state,
      assigneeIds,
      authorDisplayName: profile.displayName || "",
      reopen,
      complete,
    };
    delete task.saveError;
    delete task.open;
    delete task.scroll;

    if (!MainTask) {
      task.projectId = project.id;
      task.projectTitle = project.title;
    }

    let allCommentsInThisTask = MainTask && MainTask.comments;
    if (!allCommentsInThisTask || typeof allCommentsInThisTask != "object") {
      allCommentsInThisTask = [];
    }

    if (
      comments &&
      MainTask &&
      (MainTask.reopen || MainTask.complete || MainTask.addComment)
    ) {
      allCommentsInThisTask.push({
        comments,
        createdAt: new Date(),
        authorDisplayName: profile.displayName || "",
        authorId: profile.id,
        initials: profile.initials,
      });
    }

    task.comments = allCommentsInThisTask;

    if (!task.edit) task.edit = false;
    if (!task.reopen) task.reopen = false;
    if (!task.complete) task.complete = false;

    this.handleClose();
    createTaskReset();
    console.log("this.props.task : ", this.props.task);
    console.log("task : ", task);
    this.props.createTask(task, this.props.task);
  };

  // componentWillReceiveProps() {
  //   if (this.props.taskData.task) {
  //     const { task } = this.props.taskData;
  //     if (task) {
  //       this.handleClose();
  //       createTaskReset();
  //     }
  //   }
  // }

  getTitle = (isBtn) => {
    const { task } = this.props;
    let title = "";

    if (task && !!task.addComment) {
      return isBtn ? "Comment" : "Add Comment";
    }

    if (task) {
      if (task.edit) {
        title = "Update";
      } else if (task.complete) {
        title = "Complete";
      } else if (task.reopen) {
        title = "Reopen";
      } else {
        title = "Update";
      }
    } else {
      title = "Add";
    }

    return isBtn ? title : title + " Task";
  };

  renderInputs = () => {
    const { task } = this.props;
    const {
      title,
      startDateTime,
      endDateTime,
      content,
      assignee,
      manager,
      comments,
    } = this.state;

    // let users = [];
    // if (assignee) {
    //   users = [...assignee]
    // }
    // if (manager) {
    //   users.push({ ...manager })
    // }

    /** For add comments */
    if (task && task.addComment)
      return (
        <FormControl margin="normal" fullWidth>
          <InputLabel htmlFor="title">Comments</InputLabel>
          <Input
            onChange={this.handleChange}
            value={comments}
            multiline
            id="comments"
            name="comments"
            autoComplete="text"
          />
        </FormControl>
      );

    return (
      <div>
        {(!task || (task && task.edit)) && (
          <FormControl margin="normal" required fullWidth>
            <InputLabel htmlFor="title">Title</InputLabel>
            <Input
              onChange={this.handleChange}
              value={title}
              id="title"
              name="title"
              autoComplete="text"
            />
          </FormControl>
        )}

        {(!task || (task && task.edit)) && (
          <FormControl margin="normal" required fullWidth>
            <InputLabel htmlFor="title">Start Date Time</InputLabel>
            <Input
              onChange={this.handleChange}
              value={startDateTime}
              id="startDateTime"
              name="startDateTime"
              type="datetime-local"
            />
          </FormControl>
        )}

        {(!task ||
          (task && task.edit) ||
          (task && task.complete) ||
          (task && task.reopen && !task.complete)) && (
          <FormControl margin="normal" required fullWidth>
            <InputLabel htmlFor="title">End Date Time</InputLabel>
            <Input
              onChange={this.handleChange}
              value={endDateTime}
              id="endDateTime"
              name="endDateTime"
              type="datetime-local"
            />
          </FormControl>
        )}

        {(!task ||
          (task && task.edit) ||
          (task && task.reopen && !task.complete)) && (
          <FormControl margin="normal" required fullWidth>
            <PriorityPicker
              onChange={(priority) => {
                this.setState({ priority });
              }}
            />
          </FormControl>
        )}

        {(!task ||
          (task && task.edit) ||
          (task && task.reopen && !task.complete)) && (
          <FormControl margin="normal" required fullWidth>
            {/* userOptions={users.length ? users : null} */}
            <UserPicker
              defaultValue={task && task.assignee}
              label="Assign To"
              userOptions={null}
              onChange={(assignee) => {
                this.setState({ assignee });
              }}
              multiple
            />
          </FormControl>
        )}

        {(!task || (task && task.edit)) && (
          <div>
            <div style={{ padding: 10 }}></div>
            {/* <ReactQuill theme="snow" value={content} onChange={this.handleEditorChange} /> */}
            <CKEditor
              editor={ClassicEditor}
              data={content}
              onInit={(editor) => {
                // You can store the "editor" and use when it is needed.
                console.log("Editor is ready to use!", editor);
              }}
              onChange={(event, editor) => {
                const data = editor.getData();
                // console.log( { event, editor, data } );
                this.handleEditorChange(data);
              }}
              onBlur={(event, editor) => {
                // console.log( 'Blur.', editor );
              }}
              onFocus={(event, editor) => {
                // console.log( 'Focus.', editor );
              }}
              //   config={{ckfinder: {
              //     "headers": {
              //       "x-client-data": "CIe2yQEIo7bJAQjEtskBCKmdygEI0K/KAQi8sMoBCO21ygEIjrrKAQ==",
              //       "x-firebase-gmpid": "1:143257436076:web:faad72a2403d555a918409",
              //       authorization: "Firebase eyJhbGciOiJSUzI1NiIsImtpZCI6IjVlOWVlOTdjODQwZjk3ZTAyNTM2ODhhM2I3ZTk0NDczZTUyOGE3YjUiLCJ0eXAiOiJKV1QifQ.eyJpc3MiOiJodHRwczovL3NlY3VyZXRva2VuLmdvb2dsZS5jb20vamQtd29ya21hbmFnZXIiLCJhdWQiOiJqZC13b3JrbWFuYWdlciIsImF1dGhfdGltZSI6MTU4Nzc2ODUxNCwidXNlcl9pZCI6ImdwNldSZ2JtRXZVeWE2eHFHYU1GdjBKaXdYajIiLCJzdWIiOiJncDZXUmdibUV2VXlhNnhxR2FNRnYwSml3WGoyIiwiaWF0IjoxNTg3NzY4NTE0LCJleHAiOjE1ODc3NzIxMTQsImVtYWlsIjoiYW5pbDE1OTJndXB0YUBnbWFpbC5jb20iLCJlbWFpbF92ZXJpZmllZCI6ZmFsc2UsImZpcmViYXNlIjp7ImlkZW50aXRpZXMiOnsiZW1haWwiOlsiYW5pbDE1OTJndXB0YUBnbWFpbC5jb20iXX0sInNpZ25faW5fcHJvdmlkZXIiOiJwYXNzd29yZCJ9fQ.dzN2B1C_rWLqlmOQEXc5b7ng9i7_WSCpir9JnFU7Rx006jqckNhtUjqRVvnfBRPZlNPeyhAfRHUv21xemka9jEVuWL4kHfEISCafWoUFFEb41rj43fmIcA-CXxOKAfLXAVJ2uDTgoNJFq6Wc-m6BtCQSUH8oNsYB35Y3PrFUakmD7J1gwlqVzvaJlqg_iQeNPY-pCx9dL32tylKnYz2I9SHvqwhZpWXI82-ElkwnHBm4W8y4R0QS0tpqBmUlCD9dahrmBERWuU-CuSZqxA9bv4rLyydWvMGXg4lEGdjM6Ss9e1p9CQa3lg40r000zaV5s2-b1Bp-otvX8e_PP5yShg"

              //     },
              //     uploadUrl: 'https://jd-workmanager.appspot.com/editor'
              // }}}
            />
          </div>
        )}
        {task && (task.reopen || task.complete) && (
          <FormControl margin="normal" fullWidth>
            <InputLabel htmlFor="title">Comments</InputLabel>
            <Input
              onChange={this.handleChange}
              value={comments}
              multiline
              id="comments"
              name="comments"
              autoComplete="text"
            />
          </FormControl>
        )}
      </div>
    );
  };

  render() {
    const { open, scroll, saveError } = this.state;
    const { classes, project = {}, taskData, btn } = this.props;
    const { error, loading } = taskData;

    return (
      <div>
        {btn ? (
          btn(this.handleClickOpen("paper"))
        ) : (
          <Button
            onClick={this.handleClickOpen("paper")}
            style={{ float: "right", margin: "10px 20px -10px 0" }}
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
          >
            Add New Task{" "}
          </Button>
        )}

        {/* <Dialog
          open={open}
          disableBackdropClick
          disableEscapeKeyDown
          onClose={this.handleClose}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
          fullWidth
        > */}

        {open ? (
          <div className={classes.modalMain}>
            <div className={classes.modalInner}>
              <DialogTitle id="scroll-dialog-title">
                {this.getTitle()}
              </DialogTitle>
              <DialogContent dividers={scroll === "paper"}>
                <React.Fragment>
                  <form className={classes.form}>
                    {this.renderInputs()}
                    {loading ? <Loader /> : null}

                    {!loading && (error || saveError) ? (
                      <div>
                        {" "}
                        <br />{" "}
                        <Typography component="p" color="error" align="center">
                          {" "}
                          {(error && error.message) || saveError}
                        </Typography>{" "}
                      </div>
                    ) : null}
                  </form>
                </React.Fragment>
              </DialogContent>
              <DialogActions>
                <Button onClick={this.handleClose} color="primary">
                  Cancel
                </Button>
                <Button onClick={this.handleCreate} color="primary">
                  {this.getTitle(true)}
                </Button>
              </DialogActions>
            </div>
          </div>
        ) : null}

        {/* </Dialog> */}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    createTask: (task, id) => dispatch(createTask(task, id)),
    createTaskReset: () => dispatch(createTaskReset()),
  };
};

const mapStateToProps = (state, ownProps) => {
  return {
    auth: state.firebase.auth,
    taskData: state.task,
    profile: state.firebase.profile,
    tasks:
      state.firestore.ordered[getCollection(state.firebase.profile, "tasks")],
  };
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  firestoreConnect((props) => [])
)(withStyles(styles)(TaskForm));
